// When dimension X is selected, automatically activate or disable other dimensions depending on the datatable view
// This constant is the only single source of truth for the api.
/**
 * Example:
 * When the `salesAmountDetail` dimension is selected, the `brand_desc`
 * dimension is automatically included, and the `business_brand`
 * dimension is excluded.
 *
 * {
 *   salesAmountDetail: {
 *     barcode: {
 *       excludes: ['business_brand'],
 *       includes: ['brand_desc'],
 *     }
 *   }
 * }
 */
export const DIMENSION_DEPENDENCY_RULES_PER_DATATABLE_VIEW = {};
//# sourceMappingURL=dimensionRulesPerDatatable.constant.js.map